(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[178],{

/***/ 94897:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/login",
      function () {
        return __webpack_require__(31947);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51351);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87288);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76983);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54013);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62010);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);













/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var formRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("aa"), reload = ref[0], setReload = ref[1];
    var checkbox = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_stores__WEBPACK_IMPORTED_MODULE_6__/* .IndexContext */ .Z), setIsHeadFoot = ref1.setIsHeadFoot, getNav = ref1.getNav, setLang = ref1.setLang, lang = ref1.lang;
    var btnClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        var _values, account, password;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            _values = formRef.current.getFormState().values, account = _values.account, password = _values.password;
            formRef.current.validate().then(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                var data, ref, ref1, ref2, user;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                request.post("/exhibitor/do_login", {
                                    account: account,
                                    pwd: password
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            // let user = data?.data?.payload || {}
                            // localStorage.setItem('token', window.btoa('123'))
                            if ((data === null || data === void 0 ? void 0 : data.code) == 1) {
                                ;
                                if (checkbox.current) {
                                    user = {
                                        account: account,
                                        password: password
                                    };
                                    localStorage.setItem("user", window.btoa(JSON.stringify(user)));
                                } else {
                                    localStorage.removeItem("user");
                                }
                                document.cookie = "exhibitor_token=".concat(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.jwt, "; Expires=").concat(new Date((data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.payload) === null || ref2 === void 0 ? void 0 : ref2.expire) * 1000).toUTCString(), "; Path=/; Secure; SameSite=Lax");
                                getNav("en");
                                // localStorage.setItem('jwt', window.btoa(JSON.stringify(data?.data?.jwt)))
                                router.push("/en/index");
                            } else {
                                _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.error */ .FN.error(data === null || data === void 0 ? void 0 : data.msg);
                            }
                            return [
                                2
                            ];
                    }
                });
            })).catch(function(err) {
                _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.error */ .FN.error(Object.values(err).join(" "));
            });
            return [
                2
            ];
        });
    }), []);
    var getVerify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    // const { data } = await axios.get(`/api/get_verify`)
    // setReload('data:image/png;base64,' + arrayBufferToBase64(data?.data?.img?.data))
    // setCookie(data?.data?.cookie)
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsHeadFoot(false);
        // router.push(jwt ? '/index' : '/login')
        return function() {
            setIsHeadFoot(true);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var user = localStorage.getItem("user");
        var dec = user && JSON.parse(window.atob(user));
        if (dec) {
            formRef.current.setValues((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, dec));
        }
    }, [
        formRef.current
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().container) || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/image/logo-white.png",
                alt: "",
                className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().logo) || "")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "https://www.organic-festa.com/en",
                target: "_blank",
                className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().toHome) || ""),
                children: "Back Home"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown */ .Lt, {
                style: {
                    width: "175px"
                },
                render: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.Menu */ .Lt.Menu, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.Item */ .Lt.Item, {
                            onClick: function() {
                                return setLang("cn");
                            },
                            children: "中文"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.Item */ .Lt.Item, {
                            onClick: function() {
                                return setLang("en");
                            },
                            children: "English"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().langBtn) || ""),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "jsx-a871cd7857095582",
                            children: "Language："
                        }),
                        lang === "cn" ? "中文" : "English"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().left) || ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/image/login-title-en.png",
                    alt: "",
                    className: "jsx-a871cd7857095582"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().right) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "jsx-a871cd7857095582",
                        children: "Exhibitor Login"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                        getFormApi: function(formApi) {
                            return formRef.current = formApi;
                        },
                        labelWidth: 0,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().form) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().account) || ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                        field: "account",
                                        placeholder: "Please enter your account",
                                        noLabel: true,
                                        noErrorMessage: true,
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please enter your account"
                                            }, 
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().psw) || ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                        field: "password",
                                        type: "password",
                                        placeholder: "Please enter your password",
                                        noLabel: true,
                                        noErrorMessage: true,
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please enter your password"
                                            }, 
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().flex) || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Checkbox */ .XZ, {
                            onChange: function(e) {
                                return checkbox.current = e.target.checked;
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-a871cd7857095582",
                                children: "Remember account"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: (0,lodash__WEBPACK_IMPORTED_MODULE_7__.debounce)(function() {
                            return btnClick();
                        }, 500),
                        className: "jsx-a871cd7857095582" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().login) || ""),
                        children: "Login"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "/en/apply",
                        className: "jsx-a871cd7857095582",
                        children: "Booth Application"
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "a871cd7857095582",
                children: ".semi-form-field{}.semi-input-wrapper{background-color:transparent;border:1px solid#ddd;height:54px}.semi-input{height:100%;padding-right:142px}.semi-input-wrapper:hover{border:1px solid#0a4020;background:transparent}.semi-checkbox-inner,.semi-checkbox-inner-display{width:26px;height:26px;-webkit-border-radius:50%!important;-moz-border-radius:50%!important;border-radius:50%!important;-webkit-transform:scale(1.1);-moz-transform:scale(1.1);-ms-transform:scale(1.1);-o-transform:scale(1.1);transform:scale(1.1)}.semi-checkbox{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.semi-checkbox-inner-display,.semi-checkbox-inner-display:hover{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;background:white!important}.semi-checkbox-inner-checked .semi-checkbox-inner-display{background:#93d40b;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.semi-checkbox-inner-checked span{background:#93d40b!important;overflow:hidden}.semi-checkbox-inner-display:hover{background:#93d40b!important;border-color:#93d40b!important}.semi-checkbox-inner-display .semi-icon{font-size:20px}"
            })
        ]
    });
};


/***/ }),

/***/ 87288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"login_container__2k92E","logo":"login_logo__Kdfjd","toHome":"login_toHome__S2xPK","langBtn":"login_langBtn__pE_v1","left":"login_left__1KkjV","right":"login_right__irAGD","form":"login_form__6xAPv","account":"login_account__7t_sV","psw":"login_psw__lR7AL","vcode":"login_vcode__IvQid","flex":"login_flex__GGGO5","login":"login_login__K2s_h"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,774,888,179], function() { return __webpack_exec__(94897); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);